<template>
  <div class="container"  ref="container">
    <div class="pageContent">
      <main>
        <div :class="{'full-width white-bg': $mqBelow('DESKTOP')}">
          <ActionCard :data="params.volunteer"
                      :action-name="params.volunteer.messages.contactVolunteerBtn"
                      :action="contactVolunteer"
                      :fixed-layout="false"
                      v-if="$mqBelow('DESKTOP')"
          >
            <template #default>
              <div class="row VolonterCardOuter">
                <VolonterCard
                    :name="params.volunteer.name"
                    :url="params.volunteer.url"
                    :messages="params.volunteer.messages"
                    :spec="params.volunteer.spec"
                    :rating="params.volunteer.rating"
                    :projects="params.volunteer.projects"
                    :rang="params.volunteer.rang"
                    :photo="params.volunteer.img"
                    :showRang="params.volunteer.showRang"
                    :registration_date="params.volunteer.registration_date"
                />
              </div>
            </template>
            <template #footer>
              <!--                            <div class="flex between borderedCard">
                                              <div class="volonter-card__rang volonter-card__rang&#45;&#45;bottom"
                                                   v-if="params.volunteer.showRang">
                                                  <img
                                                      src="/local/templates/main/img/icons/rang-1.svg"
                                                      alt=""
                                                  >
                                              </div>
                                              <div>
                                                  <span>450</span>
                                                  <span>Выделено часов</span>
                                              </div>
                                              <div>
                                                  <span>10</span>
                                                  <span>Проектов</span>
                                              </div>
                                              <ABtn fill="flat" label="Добавить в избранное" @click="addFavorite(params.volunteer.id)"
                                                    color="#000" type="button"/>

                                          </div>-->
            </template>
          </ActionCard>
          <div class="full-width white-bg pos-a">
            <div class="container tabsContainer">
              <ATabs :tabs="tubTitles"
                     v-model="activeTab"
              >
              </ATabs>
            </div>

          </div>
        </div>

        <!--                @todo this section to some global structure -->
        <section id="mobile" class="mobileStructure" v-if="$mqBelow('DESKTOP')">
          <Breadcrumbs class="mb-3" :items="subHeader.breadcrumbs"/>
          <h3>{{params.volunteer.name}}</h3>
        </section>
        <!--                @todo this section to some global structure -->

        <template v-for="(tab,index) in params.tabs">
          <div v-if="index==activeTab">
            <section class="about" v-if="tab.volunteer">
              <div class="videoWrapper mb-4" v-if="tab.volunteer.video">
                <video controls :src="tab.volunteer.video">
                </video>
              </div>
              <h3 v-if="tab.volunteer.description">{{params.messages.aboutVolunteerTitle}}</h3>
              <section class="mb-4" v-html="tab.volunteer.description"></section>
            </section>
            <div class="mb-4" style="margin-bottom: 110px" v-if="tab.files">
              <h3>{{params.messages.fileVolunteerTitle}}</h3>
              <user-files :items="tab.files">
                <template #actions="{index}">
                  <a class="user-files__remove-btn" download="" :href="tab.files[index].url">{{params.messages.fileVolunteerDownload}}</a>
                </template>
              </user-files>
            </div>
            <ReviewsListSection v-if="tab.reviews" :list-data="tab.reviews" :title="tab.reviewsTitle" :count="tab.reviewsCount "/>
            <!--                  <ReviewsListSection v-if="tab.reviews?.lenght>0" :list-data="tab.reviews" title="Отзывы" :count="25"/>-->
            <section class="about" v-if="tab?.achievements">
              <Achievements  :result="tab?.achievements" :messages="params.messages"/>
            </section>

          </div>
        </template>
      </main>
      <aside>
        <ActionCard :data="params.volunteer"
                    :action-name="params.volunteer.messages.contactVolunteerBtn"
                    :action="contactVolunteer"
                    :fixed-layout="false"
                    v-if="$mqAbove('TABLET')"
        >
          <template #default>
            <div class="row">
              <VolonterCard
                  :name="params.volunteer.name"
                  :url="params.volunteer.url"
                  :spec="params.volunteer.spec"
                  :rating="params.volunteer.rating"
                  :projects="params.volunteer.projects"
                  :rang="params.volunteer.rang"
                  :photo="params.volunteer.img"
                  :messages="params.volunteer.messages"
                  :show-rang="true"
                  :registration_date="params.volunteer.registration_date"
              />
            </div>
          </template>
          <template #footer>
            <!--                        <div class="flex between borderedCard">
                                        <div class="volonter-card__rang volonter-card__rang&#45;&#45;bottom"
                                             v-if="params.volunteer.showRang">
                                            <img
                                                src="/local/templates/main/img/icons/rang-1.svg"
                                                alt=""
                                            >
                                        </div>
                                        <div>
                                            <span>450</span>
                                            <span>Выделено часов</span>
                                        </div>
                                        <div>
                                            <span>10</span>
                                            <span>Проектов</span>
                                        </div>
                                        <ABtn fill="flat" label="Добавить в избранное" @click="addFavorite(params.volunteer.id)"
                                              color="#000" type="button"/>

                                    </div>-->
          </template>
        </ActionCard>
      </aside>
    </div>
  </div>
</template>

<script>
import {
  computed, onMounted,
  ref,
} from 'vue'
import {useHeader} from "~/composables/useHeader";
import {AChip, ABtn} from '~/components/ui';
import ReviewsListSection from "~/components/sections/ReviewsListSection";
import ActionCard from "~/components/cards/ActionCard";
import ATabs from "~/components/ui/ATabs";
import ProjectListSection from "~/components/sections/ProjectListSection";
import Breadcrumbs from "~/components/main/Breadcrumbs";
import VolonterCard from "../../components/cards/VolonterCard";
import UserFiles from "../../components/cards/UserFiles";
import TopVolontersSection from "../../components/sections/TopVolontersSection";

export default {
  name: "VolunteerDetailPageContainer",
  props: {
    params: {
      type: Object,
      default: {}
    }
  },
  components: {
    VolonterCard,
    Breadcrumbs,
    ProjectListSection,
    ATabs,
    ActionCard,
    ReviewsListSection,
    AChip,
    ABtn,
    UserFiles,
    TopVolontersSection,
  },
  setup(props) {
    const {subHeader} = useHeader()
    const activeTab = ref(0);
    const container = ref(null);

    const tubTitles = computed(() => {
      let items = [];
      for(let index in props.params.tabs) {
        items.push(props.params.tabs[index].title);
      }
      return items;
    })

    const contactVolunteer = () => {
      if(props.params.volunteer.justNpoPopup) {
        showNotification(
            'nativeInfo',
            props.params.volunteer.messages.createNKOAccountTitle,
            props.params.volunteer.messages.createNKOAccountText,
            {
              actions:[
                {
                  bg:'#00A59E',
                  color:'',
                  title:props.params.volunteer.messages.createNKOAccountBtn,
                  action:false,
                  options:{
                    logoutLink:props.params.volunteer.logoutUrl
                  },
                  paternAction:'registrationNpo'
                }
              ]
            }
        );
      } else {
        window.location.href = props.params.volunteer.chatLink?props.params.volunteer.chatLink:"mailto:"+props.params.volunteer.email;
      }
    }

    const addFavorite = (id) => {
      console.log('addFavorite', id)
    }

    const downloadFile = (event, index) => {

      console.log('downloadFile', {event, index})
    }
    onMounted(() => {
      setTimeout(() => {
        window.replaceHLink(container.value);
      }, 800);
    });

    return {
      subHeader,
      activeTab,
      container,
      tubTitles,
      contactVolunteer,
      addFavorite,
      downloadFile
    }
  },
}
</script>

<style scoped lang="scss">


::v-deep .ActionCard {
  position: sticky;
  top: calc(rem(150) + rem(100));
  transform: translateY(rem(-150));

  &__footer {
    @include tablet {
      flex-grow: 1;
    }
  }

  @include tablet {
    position: relative;
    top: 0;
    transform: unset;
    box-shadow: unset;
  }

  @include tabletOnly {
    display: grid;
    grid-template-areas: 'userCard stats' 'userCard action';
    padding-bottom: rem(20);
    gap: rem(30);

    .VolonterCardOuter{
      grid-area: userCard;
    }

    .ActionCard__footer{
      grid-area: stats;
    }

    .ActionCard__button{
      grid-area: action;
      height: max-content;
      margin-top: auto;
    }

    .borderedCard{
      height: 100%;
    }
  }

  @include mobile {
    padding-bottom: rem(20);
  }
}

.tabsContainer {
  @extend %contentLayout;
}

.about {
  padding-top: rem(125);

  @include tablet {
    padding-top: 0;
  }
}

.videoWrapper {
  width: 100%;
  max-width: 100%;

  video {
    width: 100%;
  }
}

::v-deep .volonter-card {
  &__inner {
    box-shadow: unset;
    border-radius: unset;
  }

  &__rang:not(.volonter-card__rang--bottom) {
    display: none;
  }
}

::v-deep .section-top-volonters{
  background-color: transparent;

  .section__header-title {
    color: #000;
  }
}
</style>